import React from 'react';
import './PageCard.css';

function Rules() {
  return (
    <div className="page-card">
      <h2 className="page-title">Trading Rules</h2>
      <ul className="page-list">
        <li>Rule 1: Trade responsibly.</li>
        <li>Rule 2: Do not share your credentials.</li>
        <li>Rule 3: Follow market regulations.</li>
        <li>Rule 4: Monitor your risk.</li>
        <li>Rule 5: Contact support for help.</li>
      </ul>
    </div>
  );
}

export default Rules;
